var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 7.16326 24.8367 0 16 0C7.16326 0 0 7.16326 0 16C0 23.9858 5.85007 30.6062 13.4993 31.8056V20.6246H9.43644V16H13.4993V12.4753C13.4993 8.46459 15.8886 6.25067 19.5437 6.25067C21.2954 6.25067 23.1253 6.56356 23.1253 6.56356V10.5007H21.1081C19.1218 10.5007 18.5007 11.7333 18.5007 12.9991V16H22.9381L22.2293 20.6246H18.5007V31.8056C26.1499 30.6062 32 23.9858 32 16Z",
    fill: "#4676ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.227 20.6239L22.9357 15.9993H18.4984V12.9984C18.4984 11.7327 19.117 10.5001 21.1058 10.5001H23.123V6.56289C23.123 6.56289 21.293 6.25 19.5413 6.25C15.8862 6.25 13.4969 8.46393 13.4969 12.4746V15.9993H9.43408V20.6239H13.4969V31.805C14.3123 31.933 15.1467 31.9993 15.9976 31.9993C16.8486 31.9993 17.683 31.933 18.4984 31.805V20.6239H22.227Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.3ce6b73550b49cae9183537dcfa99aa1.svg";
export { ForwardRef as ReactComponent };